import './index.scss';
import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import { object } from 'prop-types';
import Scrollbar from 'react-scrollbars-custom';
import { Link, useHistory } from 'react-router-dom';
import {
  MEMBER_CENTER_TITLE,
  MEMBER_CENTER_TITLE_ES,
  MEMBER_CENTER_DESC,
  MEMBER_CENTER_DESC_ES,
  STATIC_DIV_LIMIT
} from '../../constants/defaults';
import UserBanner from './UserBanner';
import Enquiry from './Enquiry';
import SearchBar from '../SearchBar/index.jsx';
import MemberHistory from './MemberHistory';
import { getmemberHistory } from '../../services/Api/User/UserService';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { AuthContext } from '../../Contexts';
// TODO:: move notification error component and loader to common file.

const MemberCenter = ({ userPoints, location }) => {
  const [memberData, setMemberData] = useState([]);
  const [viewIndex, setViewIndex] = useState(5);
  const [showLoader, setLoader] = useState(false);
  const [notificationErr, setNotificationErr] = useState(false);
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const history = useHistory();
  const { transactions, totalTransactions } = memberData;
  const { t, i18n } = useTranslation();
  let isEs = _.isEqual(i18n.language, 'es');
  useEffect(() => {
    (async () => {
      if (!isLoggedIn) {
        history.push(isEs ? '/es' : '/');
      } else {
        setLoader(true);
        const memberHistoryResponse = await getmemberHistory();
        if (memberHistoryResponse && memberHistoryResponse.transactions) {
          setMemberData(memberHistoryResponse);
          setNotificationErr(false);
        } else {
          setNotificationErr(memberHistoryResponse.message);
        }
        setLoader(false);
      }
    })();
  }, [isLoggedIn]);

  return (
    <main>
      <div className="memberCenterContainer memberCenterMain">
        <Helmet>
          <title>{isEs ? MEMBER_CENTER_TITLE_ES : MEMBER_CENTER_TITLE}</title>
          <meta
            name="description"
            content={isEs ? MEMBER_CENTER_DESC_ES : MEMBER_CENTER_DESC}
          />
          <link
            rel="alternate"
            href="https://www.singlecare.com/member-center"
            hrefLang="en-us"
          />
          <link
            rel="alternate"
            href="https://www.singlecare.com/es/centro-de-atencion-para-miembros"
            hrefLang="es-us"
          />
          <link
            rel="canonical"
            href={`https://www.singlecare.com${location.pathname}`}
          />
        </Helmet>
        <UserBanner userPoints={userPoints} />
        <div className="activityContainer">
          {notificationErr && (
            <div className={`notification ${notificationErr ? 'visible' : ''}`}>
              {notificationErr}
              <span
                className="close-button"
                onClick={() => setNotificationErr(false)}
              >
                ×
              </span>
            </div>
          )}
          <div className="innerContainer">
            <div className="activityTable">
              <h2 className="mobile-center">
                {t('Bonus Savings Activity')}
                <span>
                  {t('Activity can take up to 24 hours to become available')}
                  <Link
                    to={_.withLocale(i18n.language, '/account-setting')}
                    className="accountInfoLink"
                  >
                    {t('MemberCenter_Account info')}
                  </Link>
                </span>
              </h2>
              {showLoader ? (
                <img
                  src="/content/images/loader/loading.gif"
                  alt={t('loader')}
                  className="searchBarLoader loaderMargin"
                  role="progressbar"
                />
              ) : (
                <>
                  {!_.isEmpty(transactions) && (
                    <div className="tableContainer">
                      <div className="tableHead">
                        <div className="desktop-only">{t('Date')}</div>
                        <div>{t('Action')}</div>
                        <div className="textCenter">
                          <span className="titleName">
                            {t('Bonus Savings')}
                          </span>
                          <span className="spanishNone">:</span>
                        </div>
                      </div>
                      <div className="tableScroll">
                        <Scrollbar
                          className="desktop-only"
                          style={{ width: 940, height: 434 }}
                        >
                          <MemberHistory
                            transactions={transactions}
                            showStaticDiv={
                              transactions.length < STATIC_DIV_LIMIT
                            }
                          />
                        </Scrollbar>
                        <div className="mobile-only">
                          <MemberHistory
                            transactions={transactions.slice(0, viewIndex)}
                          />
                        </div>
                      </div>
                      {totalTransactions > 5 &&
                        viewIndex < transactions.length && (
                          <div className="showMoreaction textCenter mobile-only">
                            <span onClick={() => setViewIndex(viewIndex + 5)}>
                              {t('Show more')}
                              <b>&#62;</b>
                            </span>
                          </div>
                        )}
                      <div className="pastDaysCount">
                        {totalTransactions > 120 && (
                          <span>
                            {t(
                              'Display history is limited to your most recent'
                            )}
                            &nbsp;
                            {t(
                              '120 transactions. For further help, please contact customer service.'
                            )}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="searchContainer">
          <div className="innerContainer">
            <div className="homepage-new">
              <h2>{t('MemberCenter_Search for a prescription')}</h2>
              <SearchBar
                buttonPlaceHolder={t('Find lowest prices')}
                showZipCode={false}
                aria={{ 'aria-labelledby': 'memberSearchPrescription' }}
              />
            </div>
          </div>
        </div>
        <Enquiry />
      </div>
    </main>
  );
};

MemberCenter.propTypes = {
  userPoints: object
};

MemberCenter.defaultProps = {
  userPoints: {}
};

export default MemberCenter;
